import React from 'react';
import { signaling } from '@lifesize/clients.sdk';
import { Box, makeStyles } from '@material-ui/core';
import { injectIntl, FormattedMessage } from 'react-intl';
import Button from 'components/Button/Button';
import { closeInCallModal } from 'actions/InCallModal';
import { useDispatch } from 'react-redux';
import { ReactComponent as WarningIcon } from '@lifesize/ux-assets/vectors/svgIcons/warning.svg';
import { colors } from '@lifesize/clients.mui-components';

const WaitingRoomWarningModal = () => {
  const classes = useStyles({});
  const dispatch = useDispatch();
  return (
    <Box className={classes.modal}>
      <Box className={classes.title}>
        <WarningIcon className={classes.warning} />
        <FormattedMessage
          id="components.waitingRoomModal.title"
          defaultMessage="There are people in your Waiting Room"
        />
      </Box>
      <Box className={classes.subTitle}>
        <FormattedMessage
          id="components.waitingRoomModal.subtitle"
          defaultMessage="Turning off waiting room will move all participants in the waiting room into your meeting. Are you okay with this?"
        />
      </Box>
      <Box className={classes.buttonBox}>
        <Button
          className={classes.button}
          kind="secondary"
          onClick={() => {
            dispatch(closeInCallModal());
          }}
          dataAttrs={{ 'data-testid': 'cancel-waiting-room-modal' }}
        >
          <FormattedMessage id="cancel" defaultMessage="Cancel" />
        </Button>

        <Button
          className={classes.button}
          kind="primary"
          onClick={() => {
            signaling.disableWaitingRoom();
            dispatch(closeInCallModal());
          }}
          dataAttrs={{ 'data-testid': 'confirm-waiting-room-modal' }}
        >
          <FormattedMessage id="confirm" defaultMessage="Confirm" />
        </Button>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex', // stretch children vertically
    minWidth: 500, // for containment in the guest join flow
    position: 'relative',
    justifyItems: 'flex-start',
    flexDirection: 'column',
    margin: 30
  },
  title: {
    display: 'flex',
    fontSize: 16,
    marginBottom: 15,
    marginLeft: 10
  },
  warning: {
    height: 24,
    width: 24,
    marginRight: 20,
    color: colors.goldenPoppy
  },
  subTitle: {
    fontSize: 12,
    marginBottom: 15
  },
  buttonBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  button: {
    minWidth: 95,
    height: 28,
    padding: 8,
    marginLeft: 15,
    fontSize: 12
  }
}));

export default injectIntl(WaitingRoomWarningModal);
